/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useState, useContext, useMemo, useEffect, useRef } from 'react';

import { CpdsSweepstakesFormsToolkitsContainer, CpdsSweepstakesFormsToolkitsHelperLabel, CpdsSweepstakesFormsToolkitsHelperTextWrapper, CpdsSweepstakesFormsToolkitsLabel, CpdsSweepstakesFormsToolkitsLabelWrapper, CpdsSweepstakesFormsToolkitsPhoneNumberContainer } from '../styles/cpds-sweepstakes-forms-toolkits-inputs-style';
import {
    BorderType, CpdsSweepstakesFormsToolkitsPhoneNumberProps
} from '../typings';
import { Cpds } from '@Cpds.Ui';
import { ThemeContext } from 'styled-components';
import { themeToken } from '../../utils/cpds-utils';
import styled, { css } from 'styled-components';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import countryCodes from '../data/country-codes';

import parsePhoneNumber, { AsYouType, CountryCode } from 'libphonenumber-js'

const isHtml = (str: string): boolean => {
    const doc = new DOMParser().parseFromString(str, 'text/html');
    return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
};

const PhoneNumber: React.FC<CpdsSweepstakesFormsToolkitsPhoneNumberProps> = ({
    inputId = "",
    domRef,
    exClasses = '',
    styleOverrides = {},
    inputWidth,
    isDisabled,
    LabelCopy,
    LabelIcon,
    LabelIconSize = { width: '10', height: '10' },
    Options = [],
    HelperCopy = '',
    HelperIcon = 'information',
    HelperIconSize = { width: '20', height: '20' },
    isError = false,
    ErrorIcon = 'information',
    ErrorIconSize = { width: '20', height: '20' },
    ErrorMessage = '',
    isOverRideTypography = false,
    PlaceholderCopy = 'Select an option',  // Default placeholder
    getValue = () => { },
    onChange = () => { },
    SelectedValue = '',
    borderType = BorderType.RoundPill,
    scrollHeight = '174px',
    ...rest
}) => {

    const { themeColorMode } = rest;
    const themeContext: any = useContext(ThemeContext);
    const cpds = themeContext?.styles?.cpds;
    const token = useMemo(() => themeToken(cpds, cpds?.themeColorMode, rest?.themeColorMode).token, [cpds, rest]);
    const [selectedCountry, setSelectedCountry] = useState<CountryCode>();
    const [inputData, setInputData] = useState('');
    const [change, setChange] = useState('');
    const [country, setCountry] = useState('');
    const [countryCode, setCountryCode] = useState('');


    const getLabelContent = () => {
        if (typeof LabelCopy === 'string') {
            const sanitizedHTML = DOMPurify.sanitize(LabelCopy);
            return parse(sanitizedHTML);
        } else if (React.isValidElement(LabelCopy) && LabelCopy.props.children) {
            const children = React.Children.map(LabelCopy.props.children, (child) => {
                if (typeof child === 'string') {
                    return parse(DOMPurify.sanitize(child));
                }
                return child;
            });
            return <>{children}</>;
        }
        return '';
    };

    const handleCountryChange = (e) => {
        const countryCode = findCountryCode("iso",e);
        if(!countryCode){
            return;
        }

        if(Array.isArray(countryCode.code)){
            setInputData(`+${countryCode.code[0]}`);
            setChange(`+${countryCode.code[0]}`);
            setCountryCode(`+${countryCode.code[0]}`);
        }else {
            setInputData(`+${countryCode.code}`);
            setChange(`+${countryCode.code}`);
            setCountryCode(`+${countryCode.code}`);
        }  
    }

    const findCountryCode = (type, value) => {
        return countryCodes.find(item => {
            return item[type] === value
        });
    }

    const handleChangeInput = (e) => {
        try {
            if(e.target.value === ""){
                setChange("");
                setCountry("");
            }else{
                const selectedCode = countryCodes.find(item => {
                    return `+${item.code}` === e.target.value
                });


                if(selectedCode){
                    setCountry(selectedCode.iso);
                }

                let parsedNumber = parsePhoneNumber(e.target.value, selectedCountry); // change 'US' to your default country code
                let parsedNewNumber = `${countryCode} ${parsedNumber.formatNational()}`
                setChange(parsedNewNumber);
            }

            
        } catch (error) {
        }
    }

    const onInputChange = useCallback(
        (e) => {
          handleChangeInput(e);
          onChange(e);
          getValue(e.target.value);
        },
        [onChange, getValue]
    );

    return (
        <CpdsSweepstakesFormsToolkitsContainer
            className={`cpds-input-checkbox ${exClasses} ${isError ? 'invalid' : ''}`}
            ref={domRef}
            style={styleOverrides}
        >
            {LabelCopy && (
                <CpdsSweepstakesFormsToolkitsLabelWrapper>
                    <CpdsSweepstakesFormsToolkitsLabel
                        className="inputbox-top-label cpds-body-roman-medium-08"
                        isDisabled={isDisabled}
                        themeColorMode={themeColorMode}
                        isOverRideTypography={isOverRideTypography}
                    >
                        {getLabelContent()}
                    </CpdsSweepstakesFormsToolkitsLabel>

                    {LabelIcon && (
                        <Cpds.Icon
                            id="ico-1"
                            name={LabelIcon}
                            customSize={LabelIconSize}
                            color={
                                isDisabled
                                    ? token?.input_fields_label_disable_icon_color || '#31374F'
                                    : token?.input_fields_label_icon_color || '#31374F'
                            }
                        />
                    )}
                </CpdsSweepstakesFormsToolkitsLabelWrapper>
            )}
            <CpdsSweepstakesFormsToolkitsPhoneNumberContainer
                isDisabled={isDisabled}
                isError={isError}
            >
                <Cpds.SweepstakesFormsToolkitsInputs.Select
                    id="key-3"
                    inputWidth={'62px'}
                    isError={isError}
                    ErrorIcon='information'
                    ErrorIconSize={{ width: '10', height: '10' }}
                    PlaceholderCopy={"Select an option"}
                    Options={
                        countryCodes.map(item => {
                            return {value: item.iso, label: `${item.country} (+${item.code})`}
                        })
                    }
                    isOverRideTypography={true}
                    getValue={setSelectedCountry}
                    onChange={handleCountryChange}
                    SelectedValue=''
                    showSelectedValue={true}
                    setChange={country}
                    className='cpds-meta-roman-book-9'
                    isDisabled={isDisabled}
                />
                <Cpds.SweepstakesFormsToolkitsInputs.Fields
                    inputId={'key-1'}
                    inputValue={inputData}
                    onChange={onInputChange}
                    inputWidth={'240px'}
                    PlaceholderCopy={''}
                    isError={isError}
                    isOverRideTypography={true}
                    borderType={BorderType.RoundPill}
                    getValue={setInputData}
                    setChange={change}
                    className='cpds-meta-roman-book-9'
                    isDisabled={isDisabled}
                />
            </CpdsSweepstakesFormsToolkitsPhoneNumberContainer>
            {isError && ErrorIcon && ErrorMessage && (
                <CpdsSweepstakesFormsToolkitsHelperTextWrapper className="sweepstake-error-wrapper">
                    {ErrorIcon && <Cpds.Icon id="ico-3" color={'#C01E1E'} name={ErrorIcon} customSize={ErrorIconSize} />}
                    <CpdsSweepstakesFormsToolkitsHelperLabel 
                        isError={isError} 
                        isDisabled={false} 
                        isOverRideTypography={isOverRideTypography}
                        className="cpds-meta-roman-book-10"
                    >
                        {ErrorMessage}
                    </CpdsSweepstakesFormsToolkitsHelperLabel>
                </CpdsSweepstakesFormsToolkitsHelperTextWrapper>
            )}

        </CpdsSweepstakesFormsToolkitsContainer>
    );
};

export default PhoneNumber;
